module.exports = __webpack_public_path__ + "img/tlf_csltdnbanner.804489b8.png";